export const getLocationName = (image) => image.location?.name || image.location_name;

export const getImageName = (image) => image.image?.name || image.name;

export const getImageUrl = (image) => image.image?.image_url || image.image_url;

/**
 * The ShowImagesMixin provides common methods to display a FancyBox viewer of the webcams
 * or trail maps displayed on a page. The showImage() method should be called to handle the
 * show-image or show-video events emitted from the <ImageView> component.
 *
 * The mixin can handle either an array of image and location objects as used in <CamViewCardList>:
 *
 * image = {
 *   image: {
 *     id: 4,
 *     image_url: 'https://webcams.opensnow.com/path/to/image',
 *     name: 'Basin Base',
 *     timelapse_url: 'https://webcams.opensnow.com/path/to/video',
 *   },
 *   location: {
 *     id: 1,
 *     name: 'Loveland Ski Area',
 *   },
 * }
 *
 * Or an array of image objects that contain location details as used in <LocationCamsCard>:
 *
 * image = {
 *   id: 4,
 *   image_url: 'https://webcams.opensnow.com/path/to/image',
 *   location_id: 1,
 *   location_name: 'Loveland Ski Area',
 *   name: 'Basin Base',
 *   timelapse_url: 'https://webcams.opensnow.com/path/to/video',
 * }
 */
export default {
  methods: {
    getLocationName(image) {
      return getLocationName(image);
    },

    getImageName(image) {
      return getImageName(image);
    },

    getImageCaption(image) {
      const imageName = this.getImageName(image);
      const locationName = this.getLocationName(image);
      return `<div class="webcam-caption">${locationName}<br />${imageName}</div>`;
    },

    getImageUrl(image) {
      return getImageUrl(image);
    },

    getVideoCaption(image) {
      const imageName = this.getImageName(image);
      return `<div class="webcam-caption">${imageName} - Timelapse</div>`;
    },

    getItems(allImages, type) {
      const getTimelapseUrl = (i) => i.image?.timelapse_url || i.timelapse_url;

      return allImages.map((image) => ({
        caption: type === 'image' ? this.getImageCaption(image) : this.getVideoCaption(image),
        src: type === 'image' ? this.getImageUrl(image) : getTimelapseUrl(image),
      }));
    },

    getOptions(image, allImages) {
      const startIndex = allImages.findIndex((i) => {
        if (i.image) {
          return i.image.id === image.image.id;
        }

        return i.id === image.id;
      });

      return {
        autoFocus: false,
        infinite: false,
        startIndex,
      };
    },

    showImage(image, type, allImages) {
      const items = this.getItems(allImages, type);
      const options = this.getOptions(image, allImages);
      window.Fancybox.show(items, options);
    },
  },
};
